<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-Next_White">
                <rect width="36" height="36"/>
            </clipPath>
        </defs>
        <g id="Next_White" clip-path="url(#clip-Next_White)">
            <rect width="36" height="36" fill="rgba(81,91,96,0)"/>
            <g id="Group_13313" data-name="Group 13313">
                <path id="Path_45" data-name="Path 45" d="M0,0H36V36H0Z" :class="svgFillClass" opacity="0"/>
                <path id="Path_46" data-name="Path 46" d="M15,9l-2.115,2.115L19.755,18l-6.87,6.885L15,27l9-9Z" :class="svgFillClass"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "arrowNextIcon",
    props: {
        width: {
            type: Number,
            default: 32
        },
        height: {
            type: Number,
            default: 32
        },
        svgFillClass: {
            type: String,
            default: 'svg-secondary-color'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/arrowNextIcon.vue